import React from 'react';

export default function LoadingView() {
  return <div>Cargando...</div>;
}
